var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100px"}},[_c('label',{staticClass:"col-form-label-sm mb-0 pb-0"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"pl-3 pr-3",staticStyle:{"margin-top":"2.2em"}},[_c('div',{ref:"slider"})])])}
var staticRenderFns = []

export { render, staticRenderFns }